/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Feature_Progress_TitleInputs */

const en_platform_feature_progress_title = /** @type {(inputs: Platform_Feature_Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress worth showing`)
};

const pl_platform_feature_progress_title = /** @type {(inputs: Platform_Feature_Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postępy, które widać`)
};

/**
* | output |
* | --- |
* | "Progress worth showing" |
*
* @param {Platform_Feature_Progress_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_feature_progress_title = /** @type {((inputs?: Platform_Feature_Progress_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Feature_Progress_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_feature_progress_title(inputs)
	return en_platform_feature_progress_title(inputs)
});